import * as r from 'react';
import { forwardRef, memo } from 'react';

var i=({title:e,titleId:o,...t},l)=>r.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",fill:"currentColor",viewBox:"0 0 16 16",ref:l,"aria-labelledby":o,...t},e?r.createElement("title",{id:o},e):null,r.createElement("path",{fill:"currentColor",d:"m14.5 8-10 5.56V2.44z"})),n=forwardRef(i),a=memo(n),V=a;

export { V as a };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-TFUWX5JE.mjs.map